import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BagdeContainer, BagdeContent, Container, TooltipLine } from './styles';

export interface IMultilinePopoverProps {
  keyid: string;
  lines?: string[];
  icon?: IconProp;
  colorIcon?: string;
  marginLeft?: string;
  bagdeValue?: string;
  bagdeTextSize?: string;
  bagdeWidth?: string;
  bagdeHeight?: string;
  bagdeBackgroundColor?: string;
  bagdeTextColor?: string;
}

export const MultilinePopover: React.FC<IMultilinePopoverProps> = ({
  keyid,
  lines,
  icon,
  colorIcon,
  marginLeft,
  bagdeValue,
  bagdeTextSize,
  bagdeWidth,
  bagdeHeight,
  bagdeBackgroundColor,
  bagdeTextColor
}) => {

  return lines && lines.length > 0 ?
    <Container marginLeft={marginLeft}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip style={{ display: 'flex', flexDirection: 'column' }}>
            {lines.map((line, nindex) => {
              return (
                <TooltipLine key={`line-popover-${keyid}-${nindex}`}>{line}</TooltipLine>
              );
            })}
          </Tooltip>
        }
      >
        {bagdeValue ? (
          <BagdeContainer backgroundColor={bagdeBackgroundColor} textColor={bagdeTextColor} width={bagdeWidth} height={bagdeHeight}>
            <BagdeContent fontSize={bagdeTextSize}>{bagdeValue}</BagdeContent>
          </BagdeContainer>
        ) : (
          <span><FontAwesomeIcon icon={icon || faExclamationTriangle} color={colorIcon || 'gray'} size='sm' /></span>
        )}
      </OverlayTrigger>
    </Container>
    : null;

}